<ng-container *transloco="let t">
  <div class="t-flex t-items-center t-justify-between">
    <p-breadcrumb [model]="breadcrumbs()"></p-breadcrumb>

    @if (isAuthenticated()) {
      <div class="t-flex t-items-center t-gap-4">
        <app-project-search></app-project-search>

        <p-button
          variant="outlined"
          severity="secondary"
          class="t-pr-4"
          size="small"
          (onClick)="alertsPopover.toggle($event)"
        >
          <span class="t-relative">
            <i class="pi pi-bell"> </i>
            @let aSummary = alertsSummary();
            @if (aSummary && aSummary.activeCount > 0) {
              <div
                class="t-absolute t-left-0 t-top-0.5 t-rounded-full t-w-1.5 t-h-1.5 t-bg-red-500 t-border t-border-white"
              ></div>
            }
          </span>
        </p-button>
      </div>
    }
  </div>

  <p-popover #alertsPopover (onShow)="checkIfFirstLoad()">
    <ng-template pTemplate="content">
      <div class="t-flex t-flex-col t-gap-3 t-min-w-[400px]">
        <div class="t-flex t-items-center t-justify-between t-pb-2 t-border-b">
          <h3 class="t-text-base t-font-semibold t-m-0 t-capitalize">
            {{ t("alert.alerts") }}
          </h3>
          <span class="t-text-sm t-text-slate-500"
            >{{ alertsSummary()?.totalCount }} {{ t("alert.alerts") }}</span
          >
        </div>

        @if (alertsSummary()?.totalCount === 0) {
          <!-- Empty State -->
          <div
            class="t-flex-1 t-flex t-flex-col t-items-center t-justify-center t-p-12"
          >
            <div class="t-text-center">
              <i
                class="pi pi-bell-slash t-text-slate-400"
                style="font-size: 4rem"
              ></i>
              <p class="t-text-slate-800 t-font-medium t-mt-4 t-text-lg">
                {{ t("alert.noAlertsFound") }}
              </p>
              <p class="t-text-slate-600 t-text-sm t-mt-2">
                {{ t("alert.noAlertsFoundDescription") }}
              </p>
            </div>
          </div>
        } @else if (isLoadingAlerts()) {
          <div class="t-w-full t-text-center t-py-5">
            <i class="pi pi-spinner pi-spin" style="font-size: 5rem"></i>
          </div>
        } @else {
          <div
            class="t-flex t-flex-col t-gap-2 t-max-h-[400px] t-overflow-y-auto"
          >
            @for (alert of alerts(); track alert.id) {
              <app-alert
                [alert]="alert"
                (dismissed)="onAlertDismissed(alert.id)"
              ></app-alert>
            }
            @if (!isLastPage()) {
              <div class="t-w-full t-flex t-justify-center t-items-center">
                <p-button
                  (onClick)="onLoadMoreClicked()"
                  [loading]="isLoadingAlerts()"
                  size="small"
                  severity="primary"
                >
                  {{ t("alert.loadMore") }}
                </p-button>
              </div>
            }
          </div>
        }
      </div>
    </ng-template>
  </p-popover>
</ng-container>
